module.exports = __webpack_public_path__ + "static/media/main_sqr.7307c5b0.mp4";